export default defineAppConfig({
  ui: {
    colors: {
      white: "white",
    },
    button: {
      variants: {
        variant: {
          none: "bg-white border border-gray-300 w-full hover:bg-gray-50 disabled:bg-gray-100",
          ghost: "disabled:opacity-50",
          link: "justify-start hover:text-white",
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class: "w-full justify-center hover:bg-primary-600",
        },
        {
          color: "neutral",
          variant: "ghost",
          class:
            "text-gray-400 hover:bg-transparent hover:text-gray-500 focus:outline-primary-500",
        },
        {
          color: "primary",
          variant: "ghost",
          class:
            "text-primary-500 hover:bg-transparent hover:text-primary-600 focus:ring-1 focus:ring-primary-500 focus-visible:bg-transparent max-w-fit p-1 inline",
        },
        {
          color: "blue",
          variant: "subtle",
          class: "border border-blue-500",
        },
      ],
      defaultVariants: {
        variant: "solid",
      },
    },
    input: {
      slots: { root: "flex" },
      variants: {
        variant: {
          none: "bg-white py-2.5 px-3.5 border border-gray-300 focus-visible:ring-2 focus-visible:ring-primary-500 disabled:bg-gray-100",
        },
      },
    },
    skeleton: {
      base: "bg-gray-200",
    },
    breadcrumb: {
      slots: {
        item: "bg-gray-50 px-2 py-1 rounded-full border border-gray-300 capitalize",
      },
    },
    toaster: {
      defaultVariants: {
        position: "top-right",
      },
    },
    checkbox: {
      slots: {
        root: "items-end",
      },
    },
    textarea: {
      slots: {
        root: "flex",
      },
      variants: {
        variant: {
          none: "bg-white py-2.5 px-3.5 border border-gray-300 focus-visible:ring-2 focus-visible:ring-primary-500 disabled:bg-gray-100",
        },
      },
    },
  },
  surveyflow: {
    range: {
      slots: {
        root: "mt-4",
        track: "h-0.5",
        thumb: "size-3",
      },
    },
    rating: {
      slots: {
        wrapper: "flex-wrap justify-start",
      },
      variants: {
        type: {
          number: {
            base: "size-6 text-xs md:size-10 sm:text-sm",
          },
          star: {
            base: "max-w-fit !bg-transparent",
          },
          heart: {
            base: "max-w-fit !bg-transparent",
          },
        },
      },
    },
  },
});
